import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { cardDetails } from "./carousel-config";
import CarouselItem from "./CarouselItem";
import "./autoplaycarousel.css";

const AutoplayCarousel = () => {
  const responsive = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
  };

  return (
    <div className="autoplay-carousel">
      <Carousel
        responsive={responsive}
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={2000}   // Adjust speed (ms)
        transitionDuration={800} // Smooth transition
        arrows={true}
        keyBoardControl={true}
        showDots={false} // You can turn this on if needed
        draggable
        swipeable
        removeArrowOnDeviceType={["tablet", "mobile"]}
      >
        {Object.values(cardDetails).map((item, index) => (
          <CarouselItem
            key={index}
            imgUrl={item.imgUrl}
            title={item.title}
            path={item.path}
          />
        ))}
      </Carousel>
    </div>
  );
};

export default AutoplayCarousel;
